<template>
  <div class="claims-page">
    <el-card shadow="never">
      <div class="page-toolbar">
        <span class="page-title">货物类型管理</span>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="openTypeDialog()"
          >添加货物类型</el-button
        >
      </div>
      <el-table
        ref="typeTable"
        v-loading="loading"
        :data="rows"
        border
        stripe
        row-key="id"
        @expand-change="loadCargoNames"
      >
        <el-table-column type="expand">
          <template slot-scope="scope">
            <div class="nested-toolbar">
              <strong>{{ scope.row.name }} - 货物品名</strong>
              <el-button
                type="primary"
                size="mini"
                @click="openCargoDialog(scope.row)"
                >添加货物品名</el-button
              >
            </div>
            <el-table :data="cargoMap[scope.row.id] || []" border size="mini">
              <el-table-column prop="name" label="货物名称" min-width="180" />
              <el-table-column label="状态" width="100" align="center">
                <template slot-scope="item"
                  ><el-tag :type="item.row.disabled ? 'info' : 'success'">{{
                    item.row.disabled ? "已禁用" : "已启用"
                  }}</el-tag></template
                >
              </el-table-column>
              <el-table-column
                prop="created_at"
                label="创建时间"
                width="180"
                :formatter="dateFormatter"
              />
              <el-table-column
                prop="updated_at"
                label="更新时间"
                width="180"
                :formatter="dateFormatter"
              />
              <el-table-column label="操作" width="150" align="center">
                <template slot-scope="item">
                  <el-button
                    type="text"
                    @click="openCargoDialog(scope.row, item.row)"
                    >编辑</el-button
                  >
                  <el-button
                    type="text"
                    @click="toggleCargo(item.row, scope.row.id)"
                    >{{ item.row.disabled ? "启用" : "禁用" }}</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="货物类型" min-width="180" />
        <el-table-column label="状态" width="100" align="center">
          <template slot-scope="scope"
            ><el-tag :type="scope.row.disabled ? 'info' : 'success'">{{
              scope.row.disabled ? "已禁用" : "已启用"
            }}</el-tag></template
          >
        </el-table-column>
        <el-table-column
          prop="created_at"
          label="创建时间"
          width="180"
          :formatter="dateFormatter"
        />
        <el-table-column
          prop="updated_at"
          label="更新时间"
          width="180"
          :formatter="dateFormatter"
        />
        <el-table-column label="操作" width="220" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="openTypeDialog(scope.row)"
              >编辑</el-button
            >
            <el-button type="text" @click="openCargoManagement(scope.row)"
              >货物品名管理</el-button
            >
            <el-button type="text" @click="toggleType(scope.row)">{{
              scope.row.disabled ? "启用" : "禁用"
            }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        :current-page="page"
        :page-size="pageSize"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[10, 15, 20, 25]"
        @current-change="handlePage"
        @size-change="handleSize"
      />
    </el-card>

    <el-dialog
      :title="
        formKind === 'type'
          ? form.id
            ? '编辑货物类型'
            : '添加货物类型'
          : form.id
          ? '编辑货物品名'
          : '添加货物品名'
      "
      :visible.sync="dialogVisible"
      width="460px"
      @closed="resetForm"
    >
      <el-form ref="form" :model="form" :rules="rules" label-width="110px">
        <el-form-item v-if="formKind === 'cargo'" label="货物类型"
          ><el-input v-model="form.cargo_type_name" disabled
        /></el-form-item>
        <el-form-item
          :label="formKind === 'type' ? '货物类型' : '货品名称'"
          prop="name"
          ><el-input v-model.trim="form.name" maxlength="64"
        /></el-form-item>
      </el-form>
      <span slot="footer"
        ><el-button @click="dialogVisible = false">取消</el-button
        ><el-button type="primary" :loading="saving" @click="save"
          >保存</el-button
        ></span
      >
    </el-dialog>
  </div>
</template>

<script>
import {
  getCargoTypes,
  saveCargoType,
  setCargoTypeDisabled,
  getCargoNames,
  saveCargoName,
  setCargoNameDisabled
} from "@/api/claims-management";
import { formatDateTime } from "./constants";

export default {
  name: "ClaimCargoTypes",
  data() {
    return {
      loading: false,
      saving: false,
      rows: [],
      total: 0,
      page: 1,
      pageSize: 15,
      cargoMap: {},
      dialogVisible: false,
      formKind: "type",
      form: { id: null, name: "", cargo_type_id: null, cargo_type_name: "" },
      rules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }]
      }
    };
  },
  created() {
    this.fetchList();
  },
  methods: {
    async fetchList() {
      this.loading = true;
      try {
        const res = await getCargoTypes({
          page: this.page,
          rows: this.pageSize
        });
        this.rows = res.rows || [];
        this.total = Number(res.total || this.rows.length);
      } finally {
        this.loading = false;
      }
    },
    async loadCargoNames(row, expanded) {
      if (expanded === false) return;
      const res = await getCargoNames({
        cargo_type_id: row.id,
        page: 1,
        rows: 1000
      });
      this.$set(this.cargoMap, row.id, res.rows || []);
    },
    openCargoManagement(row) {
      this.loadCargoNames(row, true);
      this.$refs.typeTable.toggleRowExpansion(row, true);
    },
    openTypeDialog(row) {
      this.formKind = "type";
      this.form = {
        id: row ? row.id : null,
        name: row ? row.name : "",
        cargo_type_id: null,
        cargo_type_name: ""
      };
      this.dialogVisible = true;
    },
    openCargoDialog(type, row) {
      this.formKind = "cargo";
      this.form = {
        id: row ? row.id : null,
        name: row ? row.name : "",
        cargo_type_id: type.id,
        cargo_type_name: type.name
      };
      this.dialogVisible = true;
    },
    save() {
      this.$refs.form.validate(async valid => {
        if (!valid) return;
        this.saving = true;
        try {
          const data = { name: this.form.name };
          if (this.form.id) data.id = Number(this.form.id);
          if (this.formKind === "cargo")
            data.cargo_type_id = Number(this.form.cargo_type_id);
          await (this.formKind === "type"
            ? saveCargoType(data)
            : saveCargoName(data));
          this.$message.success("保存成功");
          this.dialogVisible = false;
          if (this.formKind === "type") await this.fetchList();
          else await this.loadCargoNames({ id: this.form.cargo_type_id }, true);
        } finally {
          this.saving = false;
        }
      });
    },
    toggleType(row) {
      this.$confirm(
        `确认${row.disabled ? "启用" : "禁用"}“${row.name}”吗？`,
        "提示",
        { type: "warning" }
      )
        .then(async () => {
          await setCargoTypeDisabled({
            id: Number(row.id),
            disabled: !row.disabled
          });
          this.$message.success("修改成功");
          this.fetchList();
        })
        .catch(() => {});
    },
    toggleCargo(row, typeId) {
      this.$confirm(
        `确认${row.disabled ? "启用" : "禁用"}“${row.name}”吗？`,
        "提示",
        { type: "warning" }
      )
        .then(async () => {
          await setCargoNameDisabled({
            id: Number(row.id),
            disabled: !row.disabled
          });
          this.$message.success("修改成功");
          this.loadCargoNames({ id: typeId }, true);
        })
        .catch(() => {});
    },
    resetForm() {
      if (this.$refs.form) this.$refs.form.clearValidate();
    },
    dateFormatter(row, column, value) {
      return formatDateTime(value);
    },
    handlePage(value) {
      this.page = value;
      this.fetchList();
    },
    handleSize(value) {
      this.pageSize = value;
      this.page = 1;
      this.fetchList();
    }
  }
};
</script>

<style scoped>
.claims-page {
  padding: 20px;
}
.page-toolbar,
.nested-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}
.page-title {
  font-size: 18px;
  font-weight: 600;
}
.pagination {
  margin-top: 16px;
  text-align: right;
}
</style>
